/**
 * The three pre-session routes, aggregated.
 *
 * Plural `.routes.tsx` because the file exports an ARRAY — the importer knows
 * the shape from the name, which is the whole point of the rule.
 *
 * All three sit under the auth half-shell and none is guarded: a guard in
 * front of the sign-in screen would send an anonymous reader to the sign-in
 * screen they are already on.
 */
import type { RouteObject } from 'react-router-dom';

import { loginRoute } from './login/login.route';
import { recoverRoute } from './recover/recover.route';
import { verifyRoute } from './verify/verify.route';

export const authRoutes: RouteObject[] = [loginRoute, verifyRoute, recoverRoute];
